module.exports = __webpack_public_path__ + "media/images/team/SThorsten-64aae656c24764d426c6fa935d4aaff6.jpg";